import type { Component } from 'vue';
import { ModalSize } from '@src/application/types/modal-size.ts';

export default class Modal {
    constructor(
        public uuid: string,
        public title: string|false,
        public component: string|Component,
        public resolve: (value: any | PromiseLike<void>) => void,
        public reject: (reason?: any) => void,
        public resolveListener: string,
        public rejectListener: string|null,
        public props: object|null,
        public size: ModalSize,
    ) {
        this.uuid = uuid;
        this.title = title;
        this.component = component;
        this.resolve = resolve;
        this.reject = reject;
        this.resolveListener = resolveListener;
        this.rejectListener = rejectListener;
        this.props = props;
        this.size = size;
    }
}
